import { Badge } from 'components/ui/badge';
import { ComponentProps, ReactNode } from 'react';
import { cn } from 'utils/cn';

const FILLED_CLASS = {
    default: 'bg-grey-200 text-fg',
    success: 'bg-success text-primary-foreground',
    error: 'bg-error text-primary-foreground',
    warning: 'bg-warning text-fg new:text-primary-foreground',
    info: 'bg-info text-fg new:text-primary-foreground',
} as const;

export type ProcessChipColor = keyof typeof FILLED_CLASS;

type Props = Omit<ComponentProps<typeof Badge>, 'color'> & {
    color?: ProcessChipColor;
    outlined?: boolean;
    icon?: ReactNode;
};

/** The small status chip of the process screens: 24px tall with 4px corners, filled in its colour or outlined. */
export function ProcessChip({ color = 'default', outlined = false, icon, className, children, ...rest }: Props) {
    return (
        <Badge
            className={cn(
                'h-6 gap-1 rounded-[4px] px-2 align-middle text-[13px] font-normal [&>svg]:size-[18px]!',
                icon && 'pl-1',
                outlined ? 'border-grey-400 text-fg bg-transparent' : FILLED_CLASS[color],
                className
            )}
            {...rest}
        >
            {icon}
            {children}
        </Badge>
    );
}
